import React from 'react';
import Reflux from 'reflux';
import Button from 'bootstrap/Button';
import { Icon } from '@shoflo-rundown/polymer.legacy';
import CuesheetColumnActions from 'shared/flux/actions/cuesheet/CuesheetColumnActions';
import ConfirmActions from 'flux/actions/ConfirmActions';
import role from 'shared/lib/role';
import UserSessionStore from 'flux/stores/UserSessionStore';
import MessageConstants from 'shared/constants/Messages';
import { isGlobalElementManager } from 'main/components/show/cuesheet/cuesheetViewHelper';

export default React.createClass({
  displayName: 'AddColumnButton',

  mixins: [Reflux.connect(UserSessionStore, 'user')],

  contextTypes: {
    router: React.PropTypes.object.isRequired,
  },

  render() {
    const { teamId, eventId } = this.context.router.state.params;
    const hasEventAdmin = role.hasEventAdminRole(
      this.state.user,
      teamId,
      eventId,
    );
    if (!hasEventAdmin) return <div />;

    return (
      <Button
        onClick={this._handleAddColumnClick}
        className="button-add-column"
      >
        <Icon name="plus-circle" />
        <span>Add Column</span>
      </Button>
    );
  },

  _handleAddColumnClick() {
    if (isGlobalElementManager()) {
      ConfirmActions.prompt(
        MessageConstants.addOrDeleteGlobalColumnWarning,
        () => CuesheetColumnActions.addColumn(),
      );
    } else {
      CuesheetColumnActions.addColumn();
    }
  },
});
